const FAQ_LIST = {
  LIST_PAGE_NO_FAQ_MSG: 'No FAQ has been created for this website.',
  LIST_PAGE_HEADER_TITLE: 'Widget FAQ',
  ADD_BTN_LABEL: 'Add',
  LIST_PAGE_WEBSITE_SELECT_TITLE: 'Display for website',
  FREQUEMTLY_AKED_Q_DESC:
    'By adding frequently asked questions from the support department to this page, you create a self-service support system that helps the user find the answer to their question and solve their problem without having to communicate with the support team.',
};

export default FAQ_LIST;
